
const books = [ 
    // aysar tafaseer books 0
  [ 
      {
        "id": 0,
        "name": "الجزء الأول",
      },
      {
        "id": 1,
        "name": "الجزء الثاني",
      },
      {
        "id": 2,
        "name": "الجزء الثالث",
      },
      {
        "id": 3,
        "name": "الجزء الرابع",
      },
      {
        "id": 4,
        "name": "الجزء الخامس",
      }
  ],[
  
    // ebn katheer books 1

      {
        "id": 5,
        "name": "الجزء الأول",
      },
      {
        "id": 6,
        "name": "الجزء الثاني",
      },
      {
        "id": 7,
        "name": "الجزء الثالث",
      }
  ],[

    // tabary book 2

    {
        "id": 8,
        "name": "الجزء ١",
      },
      {
        "id": 9,
        "name": "الجزء ٢",
      },
      {
        "id": 10,
        "name": "الجزء ٣",
      },
      {
        "id": 11,
        "name": "الجزء ٤",
      },
      {
        "id": 12,
        "name": "الجزء ٥",
      },
      {
        "id": 13,
        "name": "الجزء ٦",
      },
      {
        "id": 14,
        "name": "الجزء ٧",
      },
      {
        "id": 15,
        "name": "الجزء ٨",
      },
      {
        "id": 16,
        "name": "الجزء ٩",
      },
      {
        "id": 17,
        "name": "الجزء ١٠",
      },
      {
        "id": 18,
        "name": "الجزء ١١",
      },
      {
        "id": 19,
        "name": "الجزء ١٢",
      },
      {
        "id": 20,
        "name": "الجزء ١٣",
      },
      {
        "id": 21,
        "name": "الجزء ١٤",
      },
      {
        "id": 22,
        "name": "الجزء ١٥",
      },
      {
        "id": 23,
        "name": "الجزء ١٦",
      },
      {
        "id": 24,
        "name": "الجزء ١٧",
      },
      {
        "id": 25,
        "name": "الجزء ١٨",
      },
      {
        "id": 26,
        "name": "الجزء ١٩",
      },
      {
        "id": 27,
        "name": "الجزء ٢٠",
      },
      {
        "id": 28,
        "name": "الجزء ٢١",
      },
      {
        "id": 29,
        "name": "الجزء ٢٢",
      },
      {
        "id": 30,
        "name": "الجزء ٢٣",
      },
      {
        "id": 31,
        "name": "الجزء ٢٤",
      },
      {
        "id": 32,
        "name": "الجزء ٢٥و٢٦",
      }
    ],[

      // bedaya we nehaya book 3
  
      {
          "id": 33,
          "name": "الجزء 1",
        },
        {
          "id": 34,
          "name": "الجزء 2",
        },
        {
          "id": 35,
          "name": "الجزء 3",
        },
        {
          "id": 36,
          "name": "الجزء 4",
        },
        {
          "id": 37,
          "name": "الجزء 5",
        },
        {
          "id": 38,
          "name": "الجزء 6",
        },
        {
          "id": 39,
          "name": "الجزء 7",
        },
        {
          "id": 40,
          "name": "الجزء 8",
        },
        {
          "id": 41,
          "name": "الجزء 9",
        },
        {
          "id": 42,
          "name": "الجزء 10",
        },
        {
          "id": 43,
          "name": "الجزء 11",
        },
        {
          "id": 44,
          "name": "الجزء 12",
        },
        {
          "id": 45,
          "name": "الجزء 13",
        },
        {
          "id": 46,
          "name": "الجزء 14",
        }
      ],[

        // hadeeth book 3
    
        {
            "id": 47,
            "name": "البخاري",
          },
          {
            "id": 48,
            "name": "مسلم",
          },
          // {
          //   "id": 49,
          //   "name": "",
          // },
          // {
          //   "id": 50,
          //   "name": "",
          // },
          // {
          //   "id": 51,
          //   "name": "",
          // },
          // {
          //   "id": 52,
          //   "name": "",
          // },
          // {
          //   "id": 53,
          //   "name": "",
          // },
          // {
          //   "id": 54,
          //   "name": "",
          // },
          // {
          //   "id": 55,
          //   "name": "",
          // },
          // {
          //   "id": 56,
          //   "name": "",
          // },
          // {
          //   "id": 57,
          //   "name": "",
          // },
          // {
          //   "id": 58,
          //   "name": "",
          // },
          // {
          //   "id": 59,
          //   "name": "",
          // },
          // {
          //   "id": 60,
          //   "name": "",
          // }
        ],
        [
          {
            "id": 61,
            "name": "فتح القرآن الكريم",
          }
        ]
  ]
  
  export default books;